var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gateways__option disable-select"},[_c('div',{staticClass:"gateways__image-container",on:{"click":_vm.submit}},[_c('img',{attrs:{"src":_vm.paymentImage}})]),_vm._v(" "),_c('div',{staticClass:"gateways__title"},[_vm._v("\n    "+_vm._s(this.gatewayName)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }